import React from 'react';
import {
  css, 
  Header,
} from "@bdfx/fukit"


import ctrans from "../../common/trans"
import { HorizontalBar as Bar } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import Chart from "chart.js"
import { formatInt } from '../../common/format';
Chart.pluginService.register(ChartDataLabels)

export const PriceHistogram = ({locale = "", total, data = {}, background = "#ffeced"}) => <Style className="section positions" background={background}>
                                  <div>
                                      <Header type={2}>
                                          {ctrans("position_histogram")}
                                      </Header>
                                      <Bar height={80} options={getBarOptions(total, locale)} data={getBarData(data)} />
                                  </div>
                              </Style>


const Style = css("div")({
  paddingBottom: "50px",
  background: "#ffeced",
  ".fuk-header": {
    marginTop: "-50px",
  },
  "> div": {
    position: "relative",
    zIndex: 1,
    maxWidth: "1200px",
    margin: "auto",
    },
}, props => ({ background: props.background }))


const getBarData = (data) => {

  const d = Object.keys(data).map(c => data[c])

  return ({
    labels: Object.keys(data),
    datasets: [
      {
          label: ctrans("first_position"),
          data: d.map(c => c.position_1),
          backgroundColor: "#3caea3",
          barPercentage: 1,
          categoryPercentage: 0.8, 
        },
      {
        label: ctrans("second_position"),
        data: d.map(c => c.position_2),
        backgroundColor: "#20539b",
        barPercentage: 1,
        categoryPercentage: 0.8, 
      },
      {
        label: ctrans("third_position"),
        data: d.map(c => c.position_3),
        backgroundColor: "#f6d55c",
        barPercentage: 1,
        categoryPercentage: 0.8, 
      },
    {
      label: ctrans("fourth_position"),
      data: d.map(c => c.position_4),
      backgroundColor: "#ed553b",
      barPercentage: 1,
      categoryPercentage: 0.8, 
    },
  {
    label: ctrans("out_of_bidding"),
    data: d.map(c => c.not_in_bidding),
    backgroundColor: "#aaa",
    barPercentage: 1,
    categoryPercentage: 0.8, 
  },
],
  })}
  
  const getBarOptions = (total, locale) => ({

    plugins: {
      datalabels: {
        color: '#fff',
        align: 'center',
        anchor: 'center',
        font: {
          weight: "bold",
        },
        formatter: (value,a) => {
          const percent = Math.round(value * 100 / total)
          if(percent > 1) {
            return  percent + " %"
          } else {
            return ""
          }
        }
      }
    },
    legend: {
      display: true
    },
    scales: {
      xAxes: [
        {
          stacked: true,
          scaleLabel: {
            display: true,
            labelString: `${ctrans("products_count")}`,
          },
          gridLines: {
              display: true,
              color: "#e1e1e1",
              zeroLineColor: "#e1e1e1",
            },
          ticks: {
          },

        },
  
      ],
      yAxes: [
        {
          stacked: true,
          scaleLabel: {
            display: true,
            labelString: `${ctrans("price_level")} (${ctrans("currency_"+locale)})`,
          },
          gridLines: {
            display: true,
            color: "#e1e1e1",
            zeroLineColor: "#e1e1e1",

          },
          ticks: {

            beginAtZero: true,
            callback: (value) => {
              const splitted = value.split(' - ')
              return splitted.map(s => formatInt(s)).join(' – ')
            } ,
            
          },
        },
      ],
    },
  })

  export default PriceHistogram